// @flow
import Input from './Input'
import { createFormGroupField } from '@src/components/ui/FormGroup'

export default createFormGroupField(Input)
